import { LogIn, LogOut, Timer } from "lucide-react";
import { EmptyState } from "@/components/EmptyState";
import { useI18n } from "@/i18n/I18nProvider";

export default function Clock() {
  const { t } = useI18n();
  return (
    <div>
      <h1 data-testid="clock-title" className="mb-6 font-display text-2xl font-extrabold text-[#000B45]">{t("portal.clockTitle")}</h1>
      <div className="grid grid-cols-1 gap-3">
        {[["clock-in-button", "clockIn", LogIn], ["clock-out-button", "clockOut", LogOut]].map(([id, key, Icon]) => (
          <button key={id} type="button" disabled data-testid={id} aria-disabled="true"
            className="flex min-h-[72px] cursor-not-allowed items-center justify-center gap-3 rounded-2xl border-2 border-dashed border-[#E5E7EB] bg-white text-lg font-bold text-gray-400">
            <Icon className="h-6 w-6" /> {t(`portal.${key}`)}
          </button>
        ))}
      </div>
      <div className="mt-6">
        <EmptyState testId="clock-coming-soon" icon={Timer} badge={t("common.comingSoon")} title={t("portal.clockSoon")} />
      </div>
    </div>
  );
}
